import * as React from 'react';
import { useState } from 'react';
import './AvailabilityReportForm.scss';
import '../../components/StudentHub.scss';
import { Report } from 'Src/models/report';

interface Props {
  onCancel: () => void;
  onSubmit: (data) => void;
  initialReport?: Report;
}

export function AvailabilityReportForm(props: Props) {
  const [details, setDetails] = useState(props.initialReport?.details || '');
  const [isTakePart, setIsTakePart] = useState<boolean | undefined>(
    typeof props.initialReport?.isTakePart === 'boolean' ? props.initialReport.isTakePart : undefined
  );
  const [showChoiceError, setShowChoiceError] = useState(false);

  const submitForm = () => {
    if (typeof isTakePart !== 'boolean') {
      setShowChoiceError(true);
      return;
    }
    props.onSubmit({ details, isTakePart });
  };

  const onDetailsChange = event => {
    setDetails(event.target.value);
  };

  return (
    <div className="bAvailabilityReport">
      <div className="eAvailabilityReportTitle">Can you take part?</div>
      <p className="eAvailabilityReportSubtitle">Choose an answer and add an optional note for the school.</p>

      <div className="eAvailabilityReportField">
        <div className="eAvailabilityReportChips">
          <button type="button" className={isTakePart === true ? 'is-selected is-available' : ''} onClick={() => { setIsTakePart(true); setShowChoiceError(false); }}><span>✓</span><b>Available</b></button>
          <button type="button" className={isTakePart === false ? 'is-selected is-unavailable' : ''} onClick={() => { setIsTakePart(false); setShowChoiceError(false); }}><span>×</span><b>Not available</b></button>
        </div>
        {showChoiceError ? <div className="eAvailabilityReportChoiceError" role="alert">Choose one option</div> : null}
      </div>

      <div className="eAvailabilityReportField">
        <div className="eAvailabilityReportLabel">Note for the school <span>Optional</span></div>
        <textarea
          className="eAvailabilityReportInput"
          value={details}
          placeholder={isTakePart === false ? 'For example: dentist appointment that morning' : 'For example: I’ll collect from the venue'}
          onChange={onDetailsChange}
        />
      </div>

      <div className="eAvailabilityReportActions">
        <button type="button" className="parentButton" onClick={props.onCancel}>Cancel</button>
        <button type="button" className="parentButton parentButton--primary" onClick={submitForm}>{props.initialReport ? 'Save changes' : 'Send to school'}</button>
      </div>
    </div>
  );
}
